"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var highcharts_1 = __importDefault(require("highcharts"));
var server_1 = require("react-dom/server");
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var ColorLookup_1 = __importDefault(require("../../utils/ColorLookup"));
var ShouldComponentUpdate_1 = require("../../utils/ShouldComponentUpdate");
var Bar_1 = __importDefault(require("./Bar/Bar"));
var Tooltip_1 = __importDefault(require("./Tooltip/Tooltip"));
/**
 * This component requires a commercial license. To find out more about licensing costs write an email to
 * [Martin Hlucka](mailto:Martin.Hlucka@honeywell.com)
 * @nonfree
 * @child ./Bar/Bar.tsx
 * @child ./Tooltip/Tooltip.tsx
 */
var CircleGauge = /** @class */ (function (_super) {
    __extends(CircleGauge, _super);
    function CircleGauge(props) {
        var _this = _super.call(this, props) || this;
        _this.testRefs = [];
        _this.updateChart = function () {
            _this.state.chart.update(_this.genChartOptions());
        };
        _this.genResize = function () {
            return function () {
                _this.state.chart.reflow();
            };
        };
        _this.genContent = function () {
            return React.Children.toArray(_this.props.children).map(function (child, index) {
                var type;
                if (child.type === Tooltip_1.default) {
                    type = 'Tooltip';
                }
                else if (child.type === Bar_1.default) {
                    type = 'ProgressBar';
                }
                return {
                    name: child.props.name,
                    index: index,
                    type: type,
                    props: child.props
                };
            });
        };
        _this.state = {};
        _this.baseOptions = {
            colors: props.colors,
            credits: {
                enabled: false
            },
            chart: {
                reflow: false,
                backgroundColor: 'none',
                spacing: _this.props.spacing,
                style: {
                    fontFamily: 'inherit'
                }
            },
            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                tickPositions: []
            },
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        y: -9999999,
                        enabled: false
                    }
                }
            },
            pane: {
                background: [{ outerRadius: 0 }]
            }
        };
        return _this;
    }
    CircleGauge.prototype.componentDidMount = function () {
        var options = this.genChartOptions();
        this.setState({ chart: new highcharts_1.default.Chart(options) });
    };
    CircleGauge.prototype.shouldComponentUpdate = function (nextProps) {
        return ShouldComponentUpdate_1.shouldComponentUpdate(this.props, nextProps);
    };
    CircleGauge.prototype.componentDidUpdate = function () {
        this.updateChart();
    };
    CircleGauge.prototype.componentWillUnmount = function () {
        if (this.state.chart) {
            this.state.chart.destroy();
        }
    };
    CircleGauge.prototype.render = function () {
        return (React.createElement("div", { className: "chart-wrap" },
            this.genMarkedNodes(),
            React.createElement(react_resize_detector_1.default, { refreshRate: 200, refreshMode: "throttle", handleWidth: true, handleHeight: true, skipOnMount: true, onResize: this.genResize() })));
    };
    CircleGauge.prototype.genChartOptions = function () {
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, height = _a.height, colors = _a.colors;
        var options = Object.assign(this.baseOptions, {});
        options.chart.renderTo = this.chartRef;
        if (title) {
            options.title = {
                text: title,
                margin: 20
            };
        }
        else {
            options.title = {
                text: undefined
            };
        }
        if (subtitle) {
            options.subtitle = {
                text: subtitle
            };
        }
        if (height) {
            options.chart.height = height;
        }
        options.tooltip = {
            useHTML: true,
            formatter: function () {
                return server_1.renderToString(React.createElement("div", { className: "tooltip-content" },
                    React.createElement("div", { className: "tooltip-value" }, this.x),
                    React.createElement("div", { className: "tooltip-name" },
                        React.createElement("span", { className: "label-color", style: { background: this.color } }),
                        this.series.name)));
            }
        };
        var aColor = colors.map(function (color) {
            return ColorLookup_1.default(color);
        });
        options.colors = aColor;
        options.series = new Array();
        this.testRefs.forEach(function (ref) {
            options = ref.getData(options);
        });
        return options;
    };
    CircleGauge.prototype.genMarkedNodes = function () {
        var _this = this;
        this.testRefs = [];
        var marked = React.Children.map(this.props.children, function (child, index) {
            return React.cloneElement(child, {
                ref: function (instance) {
                    if (instance && typeof instance.getData === 'function') {
                        _this.testRefs.push(instance);
                    }
                },
                chartOverview: _this.genContent(),
                index: index,
                onUpdate: _this.updateChart
            });
        });
        return (React.createElement("div", { className: this.genClasses(), ref: function (ref) { return (_this.chartRef = ref); } }, marked));
    };
    CircleGauge.prototype.genClasses = function () {
        var classes = 'ui high-chart ';
        var className = this.props.className;
        if (className) {
            classes += className;
        }
        return classes;
    };
    CircleGauge.Bar = Bar_1.default;
    CircleGauge.Tooltip = Tooltip_1.default;
    CircleGauge.defaultProps = {
        spacing: [25, 55, 25, 55],
        colors: [
            'blue',
            'green',
            'yellow',
            'orange',
            'red',
            'purple',
            'lightBlue',
            'lightGreen',
            'lightYellow',
            'lightOrange',
            'lightRed',
            'lightPurple'
        ]
    };
    return CircleGauge;
}(React.Component));
exports.default = CircleGauge;
//# sourceMappingURL=CircleGauge.js.map